import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';

import { useModal } from '../../hooks/modal';

import { Container, Content } from './styles';

interface ModalProps {
  children?: React.ReactNode;
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  const { isOpen } = useModal();

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget && onClose) {
        onClose();
      }
    },
    [onClose],
  );

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <Container onClick={handleBackdropClick}>
      <Content>{children}</Content>
    </Container>,
    document.querySelector('#modal-root') as HTMLDivElement,
  );
};

export default Modal;
